import { Stack, Text } from "prism-react";
import * as React from "react";

import { Tests } from "./Tests";
import type { Describe } from "./types";
import { isEmpty } from "./utils";

export const Describes: React.FC<{ describes: Describe[] }> = ({
  describes,
}) => {
  return (
    <>
      {describes.map((describe, index) => {
        if (isEmpty(describe)) {
          return null;
        }

        const tests = Object.values(describe.tests ?? {});
        const describes = Object.values(describe.describes ?? {});

        return (
          <Stack key={index} css={{ padding: "$2 $4 0" }} gap={0}>
            <Text>{describe.name}</Text>
            <Tests tests={tests} />
            <Describes describes={describes} />
          </Stack>
        );
      })}
    </>
  );
};
